"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeAlertModuleStatus = changeAlertModuleStatus;
exports.createAlertModule = createAlertModule;
exports.deleteAlertModule = deleteAlertModule;
exports.getAdminList = getAdminList;
exports.getAlertModuleDetail = getAlertModuleDetail;
exports.getAlertModuleList = getAlertModuleList;
exports.updateAlertModule = updateAlertModule;
exports.updateAlertModuleUsers = updateAlertModuleUsers;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 系统预警模块相关接口
 */

// 列表
function getAlertModuleList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/system/alert/module/list',
    method: 'GET',
    params: params
  });
}

// 详情
function getAlertModuleDetail(id) {
  return (0, _request.default)({
    url: "/admin/system/alert/module/".concat(id),
    method: 'GET'
  });
}

// 创建
function createAlertModule() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/system/alert/module/create',
    method: 'POST',
    data: data
  });
}

// 更新
function updateAlertModule() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/system/alert/module/update',
    method: 'POST',
    data: data
  });
}

// 删除
function deleteAlertModule(id) {
  return (0, _request.default)({
    url: "/admin/system/alert/module/delete/".concat(id),
    method: 'POST'
  });
}

// 修改启用状态
function changeAlertModuleStatus(id, enabled) {
  return (0, _request.default)({
    url: "/admin/system/alert/module/status/".concat(id),
    method: 'POST',
    params: {
      enabled: enabled
    }
  });
}

// 更新负责人
function updateAlertModuleUsers() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/system/alert/module/update-users',
    method: 'POST',
    data: data
  });
}

// 获取管理员列表（用于负责人选择）
function getAdminList() {
  return (0, _request.default)({
    url: '/admin/system/message/template/admin-list',
    method: 'GET'
  });
}